import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 80vh;
  width: 95vw;
  max-width: 1400px;
  z-index: 300;
`;
